import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Pool from "./components/Pool";
import Filter from "./components/Filter";
import Cases from "./components/Cases";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";

function App() {
  return (
    <Router>
      <Helmet>
        <title>워터피아 - 최고의 품질과 서비스를 제공하는 수영장 전문기업</title>
        <meta
          name="description"
          content="워터피아는 최고의 품질과 서비스를 제공하는 수영장 전문기업입니다. 골조 수영장, 이동식 수영장, 수영장 설비 등 다양한 서비스를 제공합니다."
        />
        <meta name="keywords" content="워터피아, 수영장, 골조수영장, 이동식수영장, 수영장설비, 여과기" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.mywaterpia.com/" />
        <meta property="og:title" content="워터피아 - 수영장 전문기업" />
        <meta
          property="og:description"
          content="최고의 품질과 서비스를 제공하는 수영장 전문기업 워터피아입니다."
        />

        {/* 추가 메타 태그 */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#3B82F6" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.mywaterpia.com/" />
      </Helmet>

      <div className="min-h-screen">
        <Header />
        <main className="pt-0">
          <Home />
          <Pool />
          <Filter />
          <Cases />
          <Gallery />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
